var store = {
  debug: true,
  state: {
    house: {},
  },
}

export default store